module.exports = __webpack_public_path__ + "static/img/4.f33100f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/culture/4.png
// module id = jFgm
// module chunks = 1